"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandSelectArgs = exports.BrandSelect = exports.WeekDaySelectArgs = exports.WeekDaySelect = exports.StaticWeekdayArgs = exports.StaticWeekday = exports.SelectArgs = exports.MultiSelectArgs = exports.MultiSelect = exports.GradeSelectArgs = exports.GradeSelect = exports.CourseListSelectArgs = exports.CourseListSelect = exports.CourseListEmptyArgs = exports.CourseListEmpty = exports.CalendarSelectArgs = exports.CalendarSelect = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_button_1 = require("../il-button/il-button");
var il_select_1 = require("./il-select");
var il_button_common_1 = require("../il-button/il-button.common");
var get_component_1 = require("../../shared/helpers/get-component");
var il_course_card_1 = require("../il-course-card/il-course-card");
var il_course_card_common_1 = require("../il-course-card/il-course-card.common");
// children
var getChildProps = function (index) { return ({
    key: index,
    variant: enums_1.ButtonVariantEnum.OUTLINED,
    sx: {
        color: 'action.disabled',
        backgroundColor: 'background.paper',
        borderColor: 'action.disabledBackground',
        '&.active, &.Mui-selected': {
            color: 'primary.contrastText',
            backgroundColor: 'primary.main',
            borderColor: 'primary.dark',
            '&:hover': {
                backgroundColor: 'primary.main',
            },
        },
        '&.MuiButtonGroup-grouped:not(:first-of-type)': {
            ml: 0,
        },
        '&.MuiButtonGroup-grouped:hover': {
            borderRightColor: 'primary.dark',
        },
        '&.MuiButtonGroup-grouped:not(:last-of-type):hover': {
            borderRightColor: 'primary.dark',
        },
    },
}); };
// default args
var SelectArgs = {
    returnValues: ['React', 'is', 'cool'],
    children: [
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(0)),
            react_1.default.createElement("a", { href: "https://reactjs.org/" }, "React")),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(1)), "is"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(2)),
            react_1.default.createElement("span", { style: { color: '#0099ff' } }, "Cool")),
    ],
    enforceValueSet: true,
};
exports.SelectArgs = SelectArgs;
var WeekDaySelectArgs = {
    'aria-label': 'weekday select',
    variant: enums_1.SelectVariantEnum.MULTI,
    component: material_1.ButtonGroup,
    children: [
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(0)), "S"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(1)), "M"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(2)), "T"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(3)), "W"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(4)), "T"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(5)), "F"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(6)), "S"),
    ],
    defaultSelections: [1, 2, 3, 4, 5],
    childSx: {
        color: 'action.disabled',
        backgroundColor: 'background.paper',
        borderColor: 'action.disabledBackground',
        width: '3em',
        fontWeight: 'normal',
        '&:hover': {
            color: 'black',
            borderColor: 'action.disabledBackground',
            backgroundColor: 'action.disabledBackground',
        },
        '&.active': {
            fontWeight: 'bold',
            color: 'primary.contrastText',
            backgroundColor: 'primary.main',
            borderColor: 'primary.dark',
            '&:hover': {
                backgroundColor: 'primary.dark',
                borderRightColor: 'primary.dark',
            },
        },
        '&.MuiButtonGroup-grouped:hover': {
            borderRightColor: 'action.disabledBackground',
        },
        '&.MuiButtonGroup-grouped:not(:last-of-type):hover': {
            borderRightColor: 'action.disabledBackground',
            '&.active': {
                borderRightColor: 'primary.main',
                '&:hover': {
                    borderRightColor: 'primary.dark',
                },
            },
        },
    },
};
exports.WeekDaySelectArgs = WeekDaySelectArgs;
var weekdays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
var weekdaysChildren = weekdays.map(function (value, index) {
    return (0, il_button_common_1.WeekdayButton)({ children: value, key: index });
});
var StaticWeekdayArgs = {
    'aria-label': 'weekday display',
    variant: enums_1.SelectVariantEnum.MULTI,
    component: material_1.Box,
    sx: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    children: weekdaysChildren,
    defaultSelections: [1, 3, 4],
};
exports.StaticWeekdayArgs = StaticWeekdayArgs;
var grades = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var gradesChildren = grades.map(function (value, index) {
    return (0, il_button_common_1.CircleButton)({ children: value, key: index });
});
var GradeSelectArgs = {
    'aria-label': 'grade select',
    component: material_1.FormGroup,
    children: gradesChildren,
    defaultSelections: [0],
    returnValues: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    sx: {
        width: '25em',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    childSx: {
        color: 'action.disabled',
        backgroundColor: 'background.default',
        borderColor: 'action.disabledBackground',
        width: '3em',
        height: '3em',
        fontSize: '1.5em',
        borderRadius: '25em',
        margin: function (theme) { return theme.spacing(1); },
        ml: 0,
        mt: 0,
        '&.active': {
            color: 'primary.contrastText',
            backgroundColor: 'primary.main',
            '&:hover': {
                backgroundColor: 'primary.main',
            },
        },
    },
};
exports.GradeSelectArgs = GradeSelectArgs;
var multiValues = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
var multiChildren = multiValues.map(function (value, index) {
    return (0, il_button_common_1.CircleButton)({ children: value, key: index });
});
var MultiSelectArgs = __assign(__assign({}, GradeSelectArgs), { 'aria-label': 'multi select', returnValues: multiValues, children: multiChildren, showSelectAll: true, variant: enums_1.SelectVariantEnum.MULTI });
exports.MultiSelectArgs = MultiSelectArgs;
var getCalendarChildProps = function (index) { return ({
    key: index,
    variant: enums_1.ButtonVariantEnum.OUTLINED,
    sx: {
        color: 'text.primary',
        fontWeight: 'normal',
        backgroundColor: 'background.default',
        borderColor: 'action.disabledBackground',
        '&.MuiButtonGroup-grouped:not(:first-of-type)': {
            ml: 0,
        },
        '&.MuiButtonGroup-grouped:hover': {
            backgroundColor: 'background.paper',
            borderColor: 'transparent',
            '&.active': {
                borderColor: 'transparent',
            },
        },
        '&.MuiButtonGroup-grouped:not(:last-of-type):hover': {
            borderColor: 'transparent',
        },
        '&.MuiButtonGroup-grouped': {
            '&.active': {
                color: 'text.primary',
                backgroundColor: '#edfcff',
                borderWidth: '2px',
                borderColor: 'primary.light',
            },
        },
    },
}); };
var CalendarSelectArgs = {
    'aria-label': 'multi select',
    returnValues: ['DAY', 'WEEK', 'MONTH'],
    component: material_1.ButtonGroup,
    children: [
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getCalendarChildProps('DAY')), "Day"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getCalendarChildProps('WEEK')), "Week"),
        react_1.default.createElement(il_button_1.ILButton, __assign({}, getCalendarChildProps('MONTH')), "Month"),
    ],
    defaultSelections: [0],
    showSelectAll: false,
    variant: enums_1.SelectVariantEnum.SINGLE,
};
exports.CalendarSelectArgs = CalendarSelectArgs;
function generateCourseCard(num) {
    return (react_1.default.createElement(material_1.ListItemButton, null,
        react_1.default.createElement(il_course_card_1.ILCourseCard, __assign({}, il_course_card_common_1.WithNotchColorArgs, { sx: __assign(__assign({}, il_course_card_common_1.WithNotchColorArgs.sx), { width: '100%', boxShadow: 'none' }),
            letterGrade: 'B', title: "Course ".concat(num.toString().padStart(2, '0')) }))));
}
var courseCardValues = Array.from({ length: 20 }, function (_value, key) { return key; });
var courseCardChildren = courseCardValues.map(function (value) {
    return generateCourseCard(value);
});
var CourseListSelectArgs = {
    'aria-label': 'course-list select',
    component: material_1.List,
    returnValues: courseCardValues,
    children: courseCardChildren,
    emptyListText: 'No Active Courses',
    defaultSelections: [0],
    sx: {
        width: '100%',
        maxHeight: 500,
        bgcolor: 'background.paper',
        overflow: 'auto',
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'column',
    },
    childSx: {
        padding: 0,
        mt: '0.25rem',
        borderRadius: '0.25rem',
        borderStyle: 'solid',
        borderWidth: '0.20rem',
        borderColor: 'action.disabledBackground',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&.Mui-selected': {
            borderColor: 'action.hover',
        },
    },
    showSelectAll: false,
    variant: enums_1.SelectVariantEnum.SINGLE,
};
exports.CourseListSelectArgs = CourseListSelectArgs;
var CourseListEmptyArgs = __assign(__assign({}, CourseListSelectArgs), { returnValues: undefined, children: undefined });
exports.CourseListEmptyArgs = CourseListEmptyArgs;
var BrandSelectArgs = {
    'aria-label': 'brand select',
    component: material_1.ButtonGroup,
    returnValues: ['MONARCH'],
    defaultSelections: [0],
    children: [react_1.default.createElement(il_button_1.ILButton, __assign({}, getChildProps(0)), "Monarch")],
};
exports.BrandSelectArgs = BrandSelectArgs;
// common components
var CalendarSelect = (0, get_component_1.getComponent)(il_select_1.ILSelect, CalendarSelectArgs);
exports.CalendarSelect = CalendarSelect;
var CourseListEmpty = (0, get_component_1.getComponent)(il_select_1.ILSelect, CourseListEmptyArgs);
exports.CourseListEmpty = CourseListEmpty;
var CourseListSelect = (0, get_component_1.getComponent)(il_select_1.ILSelect, CourseListSelectArgs);
exports.CourseListSelect = CourseListSelect;
var GradeSelect = (0, get_component_1.getComponent)(il_select_1.ILSelect, GradeSelectArgs);
exports.GradeSelect = GradeSelect;
var MultiSelect = (0, get_component_1.getComponent)(il_select_1.ILSelect, MultiSelectArgs);
exports.MultiSelect = MultiSelect;
var StaticWeekday = (0, get_component_1.getComponent)(il_select_1.ILSelect, StaticWeekdayArgs);
exports.StaticWeekday = StaticWeekday;
var WeekDaySelect = (0, get_component_1.getComponent)(il_select_1.ILSelect, WeekDaySelectArgs);
exports.WeekDaySelect = WeekDaySelect;
var BrandSelect = (0, get_component_1.getComponent)(il_select_1.ILSelect, BrandSelectArgs);
exports.BrandSelect = BrandSelect;
